import React, { useEffect, useState, useMemo, Fragment } from 'react';
import c from 'classnames';
import PropTypes from 'prop-types';
import KeyboardArrowDownSharpIcon from '@material-ui/icons/KeyboardArrowDownSharp';
import { MenuItem, Select, Tooltip } from '@material-ui/core';

import { getStaticText } from '../../../../utils/constants';
import getStaticTextDiagnose from '../../constants';
import ArrowLeft from '../../assets/ArrowLeft.svg';
import ArrowRight from '../../assets/ArrowRight.svg';
import ArrowUp from '../../assets/ArrowUp.svg';
import ArrowDown from '../../assets/ArrowDown.svg';
import {
    getBenchmarkString,
    getExSettingsBenchmarkDefault,
    getExSettingsBenchmarkForFetch,
    getEEBoxStyle,
    getRandomValues,
    manipulateHeatmapTitle,
} from '../../../../utils/functions';
import colors from '../../../../sass/colors';
import SelectModal from '../../../../components/SelectModal';
import FilterSvg from '../../assets/Filter.svg';
import ActiveFilters1 from '../../assets/ActiveFilters1.svg';
import BulletList from '../../assets/BulletList.svg';
import {
    getIndExpSectionHeading,
    isIndExpSubTabHidden,
    countIndExpHeatmapCategoryRows,
    findIndExpHeatmapHeaderIndex,
} from '../indExperiencePublicSector';
import DownloadMenu from '../DownloadMenu';
import Excel from './Excel';

function Heatmap({
    filters,
    ieHeatmap,
    ieHeatmapFetched,
    sortIeHeatmap,
    callHeatMap,
    defaultSettings,
    apiLoadingCount,
    errorInfo,
    resurveyModal,
    setReSurveyModal,
    projects,
    getDemographics,
    getBenchmarks,
    heatMapResurveyInfo,
    updateHeatMapInfo,
    getMappedDemographics,
    setReport,
    addOnTab,
    setAddOnTabs,
    appliedFiltersInfo,
    toggleFilterView,
    pptDownload,
    activeResetFilter,
    selectedDemographics,
    setSelectedDemographic,
    updateIds,
    getIeCrosstabData,
    apiParams,
    ieCrossTabData,
    heatMapData,
    getHeatMapOutcome,
    appliedBenchmark,
    footnoteList,
    getExBenchmarks,
    getComparisonYearSettings,
    compYrSettings,
    setBenchMarkForComapreYr,
    compType,
    compTypeFetched,
    getCompType,
}) {
    const {
        lang = '1033',
        report_type: surveyType = '',
        ohid = '',
        benchmark = '',
        demographic,
        quartileColors = [],
        apply_employee_exp_benchmark = false,
        engagement = '',
        ee_threshold = '',
        is_public_sector_ohi = false,
    } = defaultSettings;

    const exSettingsBenchmarkDefault = getExSettingsBenchmarkDefault(defaultSettings);

    const staticText = getStaticText(lang);
    const staticTextDiagnose = getStaticTextDiagnose(lang);
    const {
        SORT_ASCENDING,
        SORT_DESCENDING,
        QUESTIONS_HEATMAP,
        SLICE_IE_MAX_VALUE,
        SLICE_IE_MIN_VALUE,
        QUESTIONS_HEATMAP_BM,
        PS_QUESTIONS_HEATMAP,
        PS_QUESTIONS_HEATMAP_BM,
        HEADER_TRANSLATION_MAP = {},
    } = staticTextDiagnose;
    const {
        SITE_TEXT,
        IND_EXP_SCORE_CLASSIFICATION,
        QUES_LEGEND_TYPE_HEATMAP,
        NON_PROFIT_SURVEY,
        BRADESCO_IND_EXP_SCORE_CLASSIFICATION,
        BRADESCO_2025,
    } = staticText;
    const {
        N_SIZE,
        OHI_SCORE_TEXT,
        NUMBER_CAP_TEXT,
        NEGATIVE_PRACTICES,
        EE_PERCENT_FAVORABLE,
        // EE_PERCENTILE,
        NOTE,
        IND_EXP_QUESTION_NOTE,
        IND_EXP_LINKS,
        FILTERS,
        NUMBER_OF_RESPONDENTS_N,
        EMPLYEE_EXPEIENCE,
        RESURVEY_TEXT,
        EMPLOYEE_FACTORS_POSITIVE,
        EMPLOYEE_FACTORS_NEGATIVE,
        EMPLOYEE_NET_PROMOTER_SCORE,
        HEATMAP,
        EX_ENPS_HEADER,
        EE_ENPS_FOOTER,
        ADDITIONAL_PRACTICES,
        BENCHMARK_NA,
        BOTTOM_DECILE,
        BENCHMARK_HEAD,
        NO_BENCHMARK,
    } = SITE_TEXT;
    const sectionHeading = getIndExpSectionHeading(is_public_sector_ohi, EMPLYEE_EXPEIENCE, ADDITIONAL_PRACTICES);
    const isBraidesco = BRADESCO_2025.includes(ohid);
    const indExpScoreClassification = isBraidesco
        ? BRADESCO_IND_EXP_SCORE_CLASSIFICATION
        : IND_EXP_SCORE_CLASSIFICATION;
    const { demographics = [], ex_benchmarks = [] } = filters[0] || {};
    const { header = [], items = [] } = ieHeatmap || {};
    const { items: items0 = [] } = items[0] || {};
    const { score: size = '' } = items0[0] || {};
    const [minSliceValue, setMinSliceValue] = useState(SLICE_IE_MIN_VALUE);
    const [maxSliceValue, setMaxSliceValue] = useState(SLICE_IE_MAX_VALUE);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);
    const [isExBmx, setIsExBmx] = useState(false);
    const [sortOrder, setSortOrder] = useState({});
    const [dwnldDrop, showDwnldDrop] = useState(false);
    const [selectedDownload, setSelectedDownload] = useState('');
    const { selectedProjectIndex: oldIndex = '', heatMapDemo: oldDemo = '' } = heatMapResurveyInfo;
    const heatmapCategories = is_public_sector_ohi ? PS_QUESTIONS_HEATMAP : QUESTIONS_HEATMAP;
    const heatmapCategoriesBm = is_public_sector_ohi ? PS_QUESTIONS_HEATMAP_BM : QUESTIONS_HEATMAP_BM;
    const practiceCategories = apply_employee_exp_benchmark ? heatmapCategoriesBm : heatmapCategories;
    const {
        fe_ee_factor_pc_fv,
        fe_ee_enps_calc_short_pc_fv,
        com_ee_neg_enps_pc_fv,
        fe_ee_factor_percentile,
        fe_ee_enps_calc_short_percentile,
        com_ee_neg_enps_percentile,
        fe_ee_factor_pc_fv_ps,
        com_ee_neg_enps_pc_fv_ps,
    } = footnoteList || {};

    const FOOTNOTES =
        surveyType === 'percent favorable' && is_public_sector_ohi
            ? [fe_ee_factor_pc_fv_ps, fe_ee_enps_calc_short_pc_fv, com_ee_neg_enps_pc_fv_ps]
            : surveyType === 'percent favorable'
            ? [fe_ee_factor_pc_fv, fe_ee_enps_calc_short_pc_fv, com_ee_neg_enps_pc_fv]
            : [fe_ee_factor_percentile, fe_ee_enps_calc_short_percentile, com_ee_neg_enps_percentile];
    const isNonProfit = engagement === NON_PROFIT_SURVEY;

    const selectProject = (selectedProjectIndex, heatMapDemo, applyExBenchMark) => {
        if (selectedProjectIndex !== oldIndex || heatMapDemo !== oldDemo) {
            updateHeatMapInfo({
                selectedProjectIndex,
                heatMapDemo,
            });
        }
        if (selectedProjectIndex !== oldIndex) {
            const { ohid: newId, year: newYear } = projects[selectedProjectIndex];
            getDemographics({ ohid: newId, lang: parseInt(lang, 10) }, 1);
            getBenchmarks({ ohid: newId, year: newYear, lang }, 1, benchmark);
            getExBenchmarks({ ohid: newId, year: newYear, lang }, 1, getExSettingsBenchmarkForFetch(defaultSettings));
        }
        setReSurveyModal(false);
        setReport(1);
        updateIds([selectedProjectIndex]);
        setIsExBmx(applyExBenchMark);
        setBenchMarkForComapreYr(applyExBenchMark);
    };

    const headerToUse = useMemo(() => {
        if (!items.length) return [];
        return [...items.map(({ title = '' }) => title)];
        // eslint-disable-next-line
    }, [ieHeatmap]);

    const dataToUse = useMemo(() => {
        if (!items.length) return [];
        const newArray = [];
        const innerArray = [];
        items.forEach(({ items: subItem = [] }) => {
            innerArray.push(subItem);
        });
        // eslint-disable-next-line no-unused-vars
        header.forEach(i => {
            newArray.push([]);
        });
        for (let i = 0; i < innerArray.length; i += 1) {
            // const { items: subItems } = items
            for (let j = 0; j < header.length; j += 1) {
                newArray[j].push(innerArray[i][j]);
            }
        }

        return newArray;
        // eslint-disable-next-line
    }, [ieHeatmap]);

    const practiceCategoryRowCounts = useMemo(() => {
        if (!dataToUse.length) {
            return practiceCategories.map(({ children = [] }) => (children.includes('N') ? 1 : children.length));
        }
        return practiceCategories.map(({ children = [], header_slug: headerSlug = [] }) =>
            countIndExpHeatmapCategoryRows({
                children,
                headerSlug,
                header,
                arrItems: dataToUse,
                headerTranslationMap: HEADER_TRANSLATION_MAP,
            })
        );
        // eslint-disable-next-line
    }, [practiceCategories, header, dataToUse, HEADER_TRANSLATION_MAP]);

    const enpsData = useMemo(() => {
        const { items: enpsItems = [], header: headerObj = {} } = ieCrossTabData || {};
        const { items: ohiItems = [] } = heatMapData || {};
        const ohiScoreItem = ohiItems.map(({ items: subItem }) => subItem[1]);
        const headers = Object.keys(headerObj);
        if (!enpsItems.length) return [];
        const newArray = [];
        const innerArray = [];
        enpsItems.forEach(({ items: subItem = [] }) => {
            innerArray.push(subItem);
        });
        // eslint-disable-next-line no-unused-vars
        headers.forEach(i => {
            newArray.push([]);
        });
        for (let i = 0; i < innerArray.length; i += 1) {
            for (let j = 0; j < headers.length; j += 1) {
                newArray[j].push(innerArray[i][j]);
            }
        }

        return {
            enpsHeatmap: [newArray[0], ohiScoreItem, newArray[3], newArray[2], newArray[1], newArray[4]],
            enpsHeader: [enpsItems.map(({ title = '' }) => title)],
        };
        // eslint-disable-next-line
    }, [ieCrossTabData]);

    const { enpsHeatmap = [], enpsHeader = [] } = enpsData || {};

    const callEnpsHeatmapData = code => {
        // setCrossTabsDropDown([x_axis_demographic, y_axis_demographic]);
        // getCrossTab({ ...apiParams, x_axis_demographic, y_axis_demographic, threshold: rr_threshold });
        const { filters: filterParams = [] } = apiParams || {};
        const addOns = {
            others: demographic === '3' ? 1 : 0,
        };
        getIeCrosstabData({
            ohid,
            x_variable: code,
            y_variable: 'demo_IENPS1',
            filters: filterParams,
            lang: parseInt(lang, 10),
            page: 1,
            columns: 99999,
            ...addOns,
            exclude_x_variable: [],
            report_type: isExBmx ? surveyType : 'percent favorable',
            threshold: ee_threshold,
            ex_benchmarks: apply_employee_exp_benchmark
                ? getBenchmarkString(ex_benchmarks) || exSettingsBenchmarkDefault
                : '',
        });
        getHeatMapOutcome({
            ...apiParams,
            ...addOns,
            columns: 99999,
            type: 'outcome',
            demographic: code,
            threshold: ee_threshold,
        });
    };

    const renderRightOptions = () => {
        // const { demographics = [] } = filters[0] || {};
        return (
            <div className="rightOptions">
                <span>
                    <Select
                        IconComponent={KeyboardArrowDownSharpIcon}
                        value={selectedDemographics}
                        MenuProps={{
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                            transformOrigin: {
                                vertical: 'top',
                                horizontal: 'left',
                            },
                            getContentAnchorEl: null,
                        }}
                        onChange={({ target: { value: code } }) => {
                            setSelectedDemographic(code);
                            callHeatMap(code);
                            callEnpsHeatmapData(code);
                            setMinSliceValue(SLICE_IE_MIN_VALUE);
                            setMaxSliceValue(SLICE_IE_MAX_VALUE);
                        }}
                    >
                        {demographics.map(({ label, code }) => {
                            return (
                                <MenuItem classes={{ root: 'demographicOptions' }} key={code} value={code}>
                                    {label}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </span>
            </div>
        );
    };

    const getListElement = (arr, index, isNegativeTrait, isN, title, currentOhid) => {
        if (!arr || !arr.length) return null;
        const { score: innerScore, quartile = '' } = arr[index] || {};
        const {
            positiveBg = isNonProfit ? '#000000' : '#ffffff',
            negativeBg = '#ffffff',
            color: textColor = '#000000',
        } = getEEBoxStyle(innerScore, isNegativeTrait, isNonProfit, currentOhid) || {};
        const bg = isNegativeTrait ? negativeBg : positiveBg;
        const oldBg = !isN ? bg : '#ffffff';
        const oldColor = !isN ? textColor : colors.$darkBlue200;
        const border = title === 'n' ? '1px solid #e6e6e6' : '1px solid #ffffff';
        const { background: qBg = '#ffffff', color: qColor = '', border: grad = '#ffffff' } =
            quartileColors[quartile] || {};
        const background = apply_employee_exp_benchmark ? qBg : oldBg;
        const color = apply_employee_exp_benchmark ? qColor : oldColor;
        const gradient = apply_employee_exp_benchmark ? grad : oldBg;

        return (
            <li
                className={c({ bold: color === colors.$black100 }, 'contentList')}
                key={`${innerScore}${index}${getRandomValues()}`}
                style={{
                    background: `linear-gradient(135deg, ${gradient} 15%, ${background} 15%)`,
                    color,
                    border,
                }}
            >
                {!isNaN(parseInt(innerScore, 10)) ? innerScore.toLocaleString('en-US') : '-'}
            </li>
        );
    };

    const getListElementEnps = (arr, index, title) => {
        const { score: innerScore, quartile } = arr[index] || {};
        const { background = '#ffffff', color = colors.$darkBlue200, border: borderColor = '#ffffff' } =
            quartileColors[quartile] || {};
        const border = title === 'n' ? '1px solid #ffffff' : '1px solid #e6e6e6';
        if (index > enpsHeader[0].length) return null;
        return (
            <li
                className={c({ bold: color === colors.$black100 }, 'contentList')}
                key={`${innerScore}${index}${getRandomValues()}`}
                style={{
                    border,
                    background: `linear-gradient(135deg, ${borderColor} 15%, ${background} 15%)`,
                    color,
                }}
            >
                {!isNaN(parseInt(innerScore, 10)) ? innerScore.toLocaleString('en-US') : '-'}
            </li>
        );
    };

    const handleLeftClick = () => {
        setMaxSliceValue(minSliceValue);
        setMinSliceValue(minSliceValue - (SLICE_IE_MAX_VALUE - SLICE_IE_MIN_VALUE));
        setShowRightArrow(maxSliceValue >= SLICE_IE_MAX_VALUE);
        setShowLeftArrow(minSliceValue > SLICE_IE_MAX_VALUE);
    };

    const handleRightClick = () => {
        setMinSliceValue(maxSliceValue);
        setMaxSliceValue(maxSliceValue + SLICE_IE_MAX_VALUE - 1);
        setShowRightArrow(maxSliceValue + SLICE_IE_MAX_VALUE <= header.length);
        setShowLeftArrow(maxSliceValue + SLICE_IE_MAX_VALUE > SLICE_IE_MAX_VALUE);
    };

    const getEnpsHeatMapValues = itemsToIterate => {
        return (
            <Fragment>
                <div>
                    <div className="sectionDiv headerWrapper">
                        {showLeftArrow ? (
                            <div data-testid="arrowLeft" className="arrow" onClick={handleLeftClick}>
                                <img className="imgClass" src={ArrowLeft} alt="" />
                            </div>
                        ) : null}
                        {enpsHeader.length ? (
                            <ul>
                                <li className="sectionContent headerList" />
                                <li className="contentList headerList">
                                    <span className="headerLabel">{manipulateHeatmapTitle(enpsHeader[0][0])}</span>
                                </li>
                                {enpsHeader[0].slice(minSliceValue, maxSliceValue).map((val, i) => {
                                    const cellVal = manipulateHeatmapTitle(val);
                                    return (
                                        <Tooltip key={`${val}${i}`} placement="top" arrow title={val} aria-label={val}>
                                            <li className="contentList headerList">
                                                <span className="headerLabel">{cellVal}</span>
                                            </li>
                                        </Tooltip>
                                    );
                                })}
                            </ul>
                        ) : null}
                        {showRightArrow ? (
                            <div data-testid="arrowRight" className="arrow arrowRight" onClick={handleRightClick}>
                                <img className="imgClass" src={ArrowRight} alt="" />
                            </div>
                        ) : null}
                    </div>
                    {itemsToIterate.map((subItems, parentI) => {
                        const titleArr = EX_ENPS_HEADER;
                        const title = titleArr[parentI];
                        const sup = QUES_LEGEND_TYPE_HEATMAP[title] || '';
                        return (
                            <Fragment key={title + parentI + 1}>
                                <div
                                    className={c(
                                        {
                                            topPadding: parentI === 0 || parentI === 1,
                                            bottomPadding: subItems.length,
                                            borderTop: parentI === 0,
                                            n: title === 'n',
                                        },
                                        'sectionDiv'
                                    )}
                                    key={title}
                                >
                                    <ul>
                                        <Tooltip placement="top" arrow title={title} aria-label={title}>
                                            <li className="sectionContent">
                                                {title}
                                                <sup>{sup}</sup>
                                            </li>
                                        </Tooltip>
                                        {getListElementEnps(subItems, 0, title)}
                                        {subItems.slice(minSliceValue, maxSliceValue).map((_, index) => {
                                            return getListElementEnps(subItems, index + minSliceValue, title);
                                        })}
                                    </ul>
                                </div>
                            </Fragment>
                        );
                    })}
                </div>
            </Fragment>
        );
    };

    const sortData = type => {
        if (type === N_SIZE || type === OHI_SCORE_TEXT) {
            setSortOrder({ [type]: sortOrder[type] === SORT_ASCENDING ? SORT_DESCENDING : SORT_ASCENDING });
            const arr = [];
            items.map(({ items: subItems = [] }, i) => {
                const { score = '' } = type === N_SIZE ? subItems[0] || {} : subItems[1] || {};
                arr.push(score + '#' + i);
                return items;
            });
            const sortArr =
                sortOrder[type] === 1
                    ? arr.slice(1, arr.length).sort((a, b) => a.split('#')[0] - b.split('#')[0])
                    : arr.slice(1, arr.length).sort((a, b) => b.split('#')[0] - a.split('#')[0]);
            sortArr.unshift(arr[0]);
            const indexArr = [];
            sortArr.map(val => {
                return indexArr.push(arr.indexOf(val));
            });
            const output = indexArr.map(i => items[i]);
            sortIeHeatmap(output);
        }
    };

    const getHeatMapValues = arrItems => {
        return (
            <Fragment>
                <div>
                    <div className="sectionDiv headerWrapper">
                        {showLeftArrow ? (
                            <div data-testid="arrowLeft" className="arrow" onClick={handleLeftClick}>
                                <img className="imgClass" src={ArrowLeft} alt="" />
                            </div>
                        ) : null}
                        {headerToUse.length ? (
                            <ul>
                                <li className="sectionContent headerList" />
                                <li className="contentList headerList">
                                    <span className="headerLabel">{manipulateHeatmapTitle(headerToUse[0])}</span>
                                </li>
                                {headerToUse &&
                                    headerToUse.slice(minSliceValue, maxSliceValue).map((val, i) => {
                                        const cellVal = manipulateHeatmapTitle(val);
                                        return (
                                            <Tooltip
                                                key={`${val}${i}`}
                                                placement="top"
                                                arrow
                                                title={val}
                                                aria-label={val}
                                            >
                                                <li className="contentList headerList" onClick={() => sortData(val)}>
                                                    <span className="headerLabel">{cellVal}</span>
                                                    {cellVal === OHI_SCORE_TEXT && (
                                                        <img
                                                            className="arrowSort"
                                                            src={sortOrder[val] === 1 ? ArrowUp : ArrowDown}
                                                            alt=""
                                                        />
                                                    )}
                                                </li>
                                            </Tooltip>
                                        );
                                    })}
                            </ul>
                        ) : null}
                        {showRightArrow ? (
                            <div data-testid="arrowRight" className="arrow arrowRight" onClick={handleRightClick}>
                                <img className="imgClass" src={ArrowRight} alt="" />
                            </div>
                        ) : null}
                    </div>
                    {practiceCategories.map(({ children: child = [], header_slug: headerSlug = [] }, dataI) => {
                        const itemsToIterate = [];
                        const titleArr = [];
                        child.forEach((elem, childIndex) => {
                            const index = findIndExpHeatmapHeaderIndex(
                                elem,
                                childIndex,
                                headerSlug,
                                header,
                                HEADER_TRANSLATION_MAP
                            );

                            if (index !== -1 && arrItems[index] !== undefined) {
                                itemsToIterate.push(arrItems[index]);
                                titleArr.push(header[index]);
                            }
                        });
                        return itemsToIterate.map((subItems, parentI) => {
                            const title = manipulateHeatmapTitle(titleArr[parentI]);
                            const isN = titleArr[parentI] === NUMBER_CAP_TEXT;
                            const isNegativeTrait = NEGATIVE_PRACTICES.includes(title);
                            const sup = QUES_LEGEND_TYPE_HEATMAP[title] || '';
                            return (
                                <Fragment key={title + parentI + 1}>
                                    <div
                                        className={c(
                                            {
                                                topPadding: parentI === 0 || (!dataI && parentI === child.length - 1),
                                                bottomPadding: parentI === child.length - 1,
                                                borderTop: parentI === 0,
                                                n: title === 'n',
                                            },
                                            'sectionDiv'
                                        )}
                                        key={title}
                                    >
                                        {/* {showCategoryI === parentI ? (
                                            <ul>
                                                <li className="sectionContent headerContent">{categoryN}</li>
                                            </ul>
                                        ) : null} */}
                                        <ul>
                                            <li className="sectionContent">
                                                <Tooltip placement="top" arrow title={title} aria-label={title}>
                                                    <span className="headerLabel">{title}</span>
                                                </Tooltip>
                                                <sup>{sup}</sup>
                                            </li>
                                            {getListElement(subItems, 0, isNegativeTrait, isN, title, ohid)}
                                            {subItems
                                                ?.slice(minSliceValue, maxSliceValue)
                                                ?.map((_, index) =>
                                                    getListElement(
                                                        subItems,
                                                        index + minSliceValue,
                                                        isNegativeTrait,
                                                        isN,
                                                        title,
                                                        ohid
                                                    )
                                                )}
                                        </ul>
                                    </div>
                                </Fragment>
                            );
                        });
                    })}
                </div>
            </Fragment>
        );
    };

    useEffect(() => {
        if (!ieHeatmapFetched) {
            const { code = '' } = demographics[0] || {};
            const demo = selectedDemographics || code;
            callHeatMap(demo);
            callEnpsHeatmapData(demo);
            setSelectedDemographic(demo);
        }
        // eslint-disable-next-line
    }, [ieHeatmapFetched]);

    useEffect(() => {
        if (items.length - 1 >= maxSliceValue) {
            setShowRightArrow(true);
        } else {
            setShowRightArrow(false);
        }
        // eslint-disable-next-line
    }, [maxSliceValue, items]);
    const sup = 1;
    return (
        <Fragment>
            <div className="scoreBoard addOns clearfix">
                <div className="indExpBoard">
                    <div className="rightScorecardHeader">
                        <div className="scorecardHeading">
                            <div className="mainHeading">
                                {sectionHeading} {resurveyModal ? 'Resurvey' : ''}
                                <sup>{sup}</sup>
                            </div>
                            <div className="nRes">
                                {NUMBER_OF_RESPONDENTS_N} : <span>{size.toLocaleString('en-US')}</span>
                            </div>
                        </div>
                        <ul className="navScoreList">
                            {!is_public_sector_ohi ? (
                                <li
                                    data-testid="setReSurveyModalBtn"
                                    onClick={() => setReSurveyModal(true)}
                                    className="fImage resurveyImg"
                                >
                                    <img src={BulletList} alt="" />
                                    <span className="upperHead">{RESURVEY_TEXT}</span>
                                </li>
                            ) : null}
                            {!errorInfo && (
                                <DownloadMenu
                                    lang={lang}
                                    dwnldDrop={dwnldDrop}
                                    showDwnldDrop={showDwnldDrop}
                                    onPpt={pptDownload}
                                    onExcel={() => {
                                        setSelectedDownload('excel');
                                        setTimeout(() => setSelectedDownload(''));
                                    }}
                                />
                            )}
                            <li onClick={() => toggleFilterView(true)} data-testid="filterButton">
                                <img src={activeResetFilter ? ActiveFilters1 : FilterSvg} alt="" />
                                <span className="filter">{FILTERS}</span>
                            </li>
                        </ul>
                    </div>
                    {appliedFiltersInfo()}
                    {appliedBenchmark()}

                    <div className={`optionWrapper ${addOnTab === 1 ? 'stickyTop' : ''}`}>
                        <div>
                            <ul className="leftNav">
                                {IND_EXP_LINKS.map((tabName, index) => {
                                    if (
                                        isIndExpSubTabHidden(index, is_public_sector_ohi) ||
                                        (!apply_employee_exp_benchmark && index === 4) ||
                                        (surveyType === 'percentile' && index === 4)
                                    )
                                        return null;
                                    return (
                                        <li
                                            data-testid={tabName}
                                            key={tabName}
                                            className={c({ activeLink: addOnTab === index })}
                                            onClick={() => setAddOnTabs(index)}
                                        >
                                            {tabName}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        {renderRightOptions()}
                    </div>
                    {ieHeatmapFetched && (
                        <Fragment>
                            <div className="demographicHeatmapBoard">
                                <div className="heatmapBoard clearfix clearPadding">
                                    <section
                                        className={c({ wrapperShadow: headerToUse.length <= 6 }, 'sectionWrapper')}
                                    >
                                        <div className={c({ psOhiOutcomeNames: is_public_sector_ohi }, 'outcomeNames')}>
                                            {practiceCategories.map(({ title: name = '' }, elem) => {
                                                const len = practiceCategoryRowCounts[elem] || 0;
                                                if (!len) return null;
                                                return (
                                                    <div key={name} style={{ height: `${len * 7 + 2}vh` }}>
                                                        <span>{name}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="contentWrapper clearfix">
                                            <div
                                                className={c({ noPadding: headerToUse.length <= 6 }, 'mainContent')}
                                                id="myHeader"
                                            >
                                                {dataToUse.length ? getHeatMapValues(dataToUse) : null}
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            {enpsHeatmap.length ? (
                                <h2 className="enpsHeader">
                                    {EMPLOYEE_NET_PROMOTER_SCORE} (eNPS) {HEATMAP}
                                </h2>
                            ) : null}
                            <div className="demographicHeatmapBoard">
                                <div className="heatmapBoard clearfix clearPadding">
                                    <section className="sectionWrapper wrapperShadow">
                                        <div className="outcomeNames" />
                                        <div className="contentWrapper clearfix">
                                            <div
                                                className={c({ noPadding: enpsHeader[0]?.length <= 6 }, 'mainContent')}
                                                id="myHeader"
                                            >
                                                {enpsHeatmap.length ? getEnpsHeatMapValues(enpsHeatmap) : null}
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            {resurveyModal && (
                                <SelectModal
                                    defaultSettings={defaultSettings}
                                    oldSelectedId={oldIndex}
                                    oldSelectedDemo={oldDemo}
                                    projects={projects}
                                    projectsFetched
                                    closeModal={setReSurveyModal}
                                    selectProject={selectProject}
                                    demographics={demographics}
                                    current_ohid={ohid}
                                    apiLoadingCount={apiLoadingCount}
                                    heatMapResurvey
                                    getMappedDemographics={getMappedDemographics}
                                    getComparisonYearSettings={getComparisonYearSettings}
                                    compYrSettings={compYrSettings}
                                    isExModule
                                    compType={compType}
                                    compTypeFetched={compTypeFetched}
                                    getCompType={getCompType}
                                />
                            )}
                            {!apiLoadingCount && !errorInfo && (
                                <Fragment>
                                    {surveyType === 'percent favorable' && is_public_sector_ohi ? (
                                        <div className="note">
                                            <b>{NOTE}:</b>
                                            {FOOTNOTES.map((txt, i) => {
                                                return <div>{`${i + 1}. ${txt}`}</div>;
                                            })}
                                        </div>
                                    ) : apply_employee_exp_benchmark ? (
                                        <div className="note">
                                            <b>{NOTE}:</b>
                                            {FOOTNOTES.map((txt, i) => {
                                                return <div>{`${i + 1}. ${txt}`}</div>;
                                            })}
                                        </div>
                                    ) : (
                                        <div className="note">
                                            <b>{NOTE}:</b>
                                            <div>1. {EE_PERCENT_FAVORABLE}</div>
                                            {IND_EXP_QUESTION_NOTE[0]}
                                            <br />
                                            {IND_EXP_QUESTION_NOTE[1]}
                                            <div>4. {EE_ENPS_FOOTER}</div>
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </Fragment>
                    )}
                </div>
            </div>
            <ul className="fixedScoreCardSurvey">
                {apply_employee_exp_benchmark ? (
                    <ul className="benchmark clearfix">
                        <li>{BENCHMARK_HEAD} : </li>
                        {quartileColors
                            .slice()
                            .reverse()
                            .map(({ title, background, border: borderColor }) => {
                                const bottomDecileVar = title === BOTTOM_DECILE;
                                const BenchmarkTitle = title === NO_BENCHMARK;
                                return (
                                    <li
                                        key={title}
                                        style={{ color: background }}
                                        className={c({
                                            hide: bottomDecileVar || BenchmarkTitle,
                                        })}
                                    >
                                        <span
                                            className="benchmarkTriangle"
                                            style={{
                                                background,
                                                borderWidth: '13px 13px 0 0',
                                                borderColor: bottomDecileVar
                                                    ? `transparent ${borderColor} transparent transparent`
                                                    : `${borderColor} transparent transparent transparent`,
                                                borderStyle: 'solid',
                                            }}
                                        />
                                        <div style={{ color: 'black' }}>{title}</div>
                                    </li>
                                );
                            })}
                        <li>
                            <span style={{ background: colors.$white, border: '1.5px solid #e6e6e6' }} />
                            {BENCHMARK_NA}
                        </li>
                    </ul>
                ) : (
                    <Fragment>
                        <ul className="benchmark clearfix">
                            <li>{EMPLOYEE_FACTORS_POSITIVE} : </li>
                            {indExpScoreClassification.map(({ title, positiveBg: background }) => (
                                <li key={title}>
                                    <span style={{ background, border: 'none' }} />
                                    {title}
                                </li>
                            ))}
                        </ul>
                        <ul className="benchmark clearfix">
                            <li>{EMPLOYEE_FACTORS_NEGATIVE} : </li>
                            {indExpScoreClassification.map(({ titleNeg, title, negativeBg: background }) => (
                                <li key={titleNeg}>
                                    <span style={{ background, border: 'none' }} />
                                    {isNonProfit ? title : titleNeg}
                                </li>
                            ))}
                        </ul>
                    </Fragment>
                )}
            </ul>
            {selectedDownload === 'excel' ? (
                <Excel
                    headerToUse={headerToUse}
                    dataToUse={dataToUse}
                    header={header}
                    practiceCategories={practiceCategories}
                    enpsHeatmap={enpsHeatmap}
                    enpsHeader={enpsHeader}
                    filters={filters}
                    selectedDemographics={selectedDemographics}
                    defaultSettings={defaultSettings}
                    headerTranslationMap={HEADER_TRANSLATION_MAP}
                    setSelectedDownload={setSelectedDownload}
                />
            ) : null}
        </Fragment>
    );
}

Heatmap.propTypes = {
    filters: PropTypes.array.isRequired,
    ieHeatmap: PropTypes.object.isRequired,
    ieHeatmapFetched: PropTypes.bool.isRequired,
    callHeatMap: PropTypes.func.isRequired,
    sortIeHeatmap: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    apiLoadingCount: PropTypes.number.isRequired,
    errorInfo: PropTypes.number.isRequired,
    addOnTab: PropTypes.number.isRequired,
    setAddOnTabs: PropTypes.func.isRequired,
    appliedFiltersInfo: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    pptDownload: PropTypes.func.isRequired,
    activeResetFilter: PropTypes.bool.isRequired,
    setSelectedDemographic: PropTypes.func.isRequired,
    selectedDemographics: PropTypes.string.isRequired,
    resurveyModal: PropTypes.bool.isRequired,
    setReSurveyModal: PropTypes.func.isRequired,
    heatMapResurveyInfo: PropTypes.object.isRequired,
    getMappedDemographics: PropTypes.func.isRequired,
    updateHeatMapInfo: PropTypes.func.isRequired,
    getDemographics: PropTypes.func.isRequired,
    getBenchmarks: PropTypes.func.isRequired,
    setReport: PropTypes.func.isRequired,
    projects: PropTypes.array.isRequired,
    updateIds: PropTypes.array.isRequired,
    getIeCrosstabData: PropTypes.func.isRequired,
    apiParams: PropTypes.object.isRequired,
    ieCrossTabData: PropTypes.object.isRequired,
    heatMapData: PropTypes.object.isRequired,
    getHeatMapOutcome: PropTypes.func.isRequired,
    appliedBenchmark: PropTypes.func.isRequired,
    footnoteList: PropTypes.array.isRequired,
    getExBenchmarks: PropTypes.func.isRequired,
    getComparisonYearSettings: PropTypes.func.isRequired,
    compYrSettings: PropTypes.object.isRequired,
    setBenchMarkForComapreYr: PropTypes.func.isRequired,
    compType: PropTypes.object.isRequired,
    compTypeFetched: PropTypes.bool.isRequired,
    getCompType: PropTypes.func.isRequired,
};

export default Heatmap;
